import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13e45317"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ci-action-edit block text-lg mr-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "app-label-small font-bold" }, "Paramètres de compte")
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Changement d'e-mail", -1))
const _hoisted_4 = { class: "flex flex-column w-full gap-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-l1 app-label-micro font-bold",
  for: "previous-email"
}, "ANCIEN MAIL", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-l1 app-label-micro font-bold",
  for: "new-email"
}, "NOUVELLE ADRESSE E-MAIL", -1))
const _hoisted_7 = {
  key: 0,
  class: "text-red app-label-micro font-medium mt-1 mb-1"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Un mail a été envoyé pour confirmer le changement.", -1))
const _hoisted_10 = { class: "flex flex-column app-label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-325" }, "Vous recevrez d’ici quelques minutes un mail à l'adresse", -1))
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-325" }, "Si vous ne recevez pas de mail, veuillez contacter le service client.", -1))
const _hoisted_14 = { class: "button-container" }
const _hoisted_15 = { class: "flex flex-row justify-content-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.dialogVisible,
    "onUpdate:visible": [
      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      _ctx.setVisible
    ],
    modal: true,
    class: "p-fluid",
    closable: _ctx.closable,
    dismissableMask: true,
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: { width: '50vw' }
  }, _createSlots({
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (!_ctx.emailSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _hoisted_5,
                _createVNode(_component_InputText, {
                  id: "previous-email",
                  modelValue: _ctx.user.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.email) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_6,
                _createVNode(_component_InputText, {
                  id: "new-email",
                  modelValue: _ctx.v$.newMail.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.newMail.$model) = $event)),
                  class: _normalizeClass({
                'p-invalid': _ctx.errorMessage
              })
                }, null, 8, ["modelValue", "class"]),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.newMail), 1),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_app_button, {
                buttonType: "secondary",
                buttonSize: "m",
                buttonText: "Renvoyer un mail",
                isDisabled: false,
                onClick: _ctx.changeMail
              }, null, 8, ["onClick"])
            ])
          ]))
    ]),
    _: 2
  }, [
    (!_ctx.emailSent)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_app_button, {
                buttonType: "secondary",
                buttonSize: "m",
                buttonText: "Annuler",
                isDisabled: false,
                onClick: _ctx.hide
              }, null, 8, ["onClick"]),
              _createVNode(_component_app_button, {
                buttonType: "main",
                buttonSize: "m",
                buttonText: "Confirmer",
                onClick: _ctx.changeMail,
                disabled: _ctx.errorMessage
              }, null, 8, ["onClick", "disabled"])
            ])
          ])
        }
      : undefined
  ]), 1032, ["visible", "closable", "onUpdate:visible"]))
}